<template>
  <nav
    class="navbar navbar-expand-lg theme-nav fixed-top" :class="display?'darkHeader':''"
    v-on:scroll="handleScroll"
  >
    <div class="container">
      <router-link class="navbar-brand" to="/chatloop"
        ><img src="../../assets/images/logo.png" alt="logo"
      /></router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#mainmenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleNavbar('navbar')"
      >
        <span class="navbar-toggler-icon"
          ><i class="fa fa-align-justify" aria-hidden="true"></i
        ></span>
      </button>
      <div
        class="collapse navbar-collapse"
        :class="responsiveNav ? 'show' : ''"
        id="mainmenu"
      >
        <ul class="navbar-nav ml-auto" id="mymenu">
          <li
            class="nav-item"
            :class="active['home'] ? 'active' : ''"
          >
            <router-link
              class="nav-link"
              to="/chatloop/rtl/#home"
              :class="active['home'] ? 'active' : ''"
              >Home</router-link
            >
          </li>
          <li
            class="nav-item"
            :class="active['about'] ? 'active' : ''"
          >
            <router-link
              class="nav-link"
              to="/chatloop/rtl/#about"
              :class="active['about'] ? 'active' : ''"
              >about</router-link
            >
          </li>
          <li
            class="nav-item"
            :class="active['feature'] ? 'active' : ''"
          >
            <router-link
              class="nav-link"
              to="/chatloop/rtl/#feature"
              :class="active['feature'] ? 'active' : ''"
              >feature</router-link
            >
          </li>
          <li
            class="nav-item"
            :class="active['screenshot'] ? 'active' : ''"
          >
            <router-link
              class="nav-link"
              to="/chatloop/rtl/#screenshots"
              :class="active['screenshot'] ? 'active' : ''"
              >screenshot</router-link
            >
          </li>
          <li
            class="nav-item"
            :class="active['team'] ? 'active' : ''"
          >
            <router-link
              class="nav-link"
              to="/chatloop/rtl/#team"
              :class="active['team'] ? 'active' : ''"
              >team</router-link
            >
          </li>
          <li
            class="nav-item dropdown"
            @click="toggleNavbar('blogList')"
            :class="active['blog'] ? 'active' : ''"
          >
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :class="active['blog'] ? 'active' : ''"
              >Blog</a
            >
            <ul class="dropdown-menu" :class="responsiveBlogList ? 'show' : ''">
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blog-list"
                  >blog list</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blog-details"
                  >blog details</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blogs-leftside"
                  >leftsidebar</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blogs-rightside"
                  >rightsidebar</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  to="/chatloop/rtl/blog-details-with-left-sidebar"
                  >details leftsidebar
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  to="/chatloop/rtl/blog-details-with-right-sidebar"
                  >details rightsidebar
                </router-link>
              </li>
            </ul>
          </li>
          <li
            class="nav-item"
            :class="active['contactUs'] ? 'active' : ''"
          >
            <router-link
              class="nav-link"
              to="/chatloop/rtl/#contact"
              :class="active['contactUs'] ? 'active' : ''"
              >contact us</router-link
            >
          </li>
          <li class="nav-item dropdown" @click="toggleNavbar('otherPagesList')">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Other Page
            </a>
            <ul
              class="dropdown-menu"
              :class="responsiveOthePageslist ? 'show' : ''"
            >
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/sign-in"
                  >Sign In</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/sign-up"
                  >Sign Up</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/forgot-password"
                  >Forget Password</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/thank-you"
                  >Thank You</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/review"
                  >Review</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/FAQ-page"
                  >FAQ</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/coming-soon"
                  >Coming Soon</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/download"
                  >Download</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/request"
                  >Request Demo</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/404"
                  >404</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "Navbar",
  data() {
    return {
      scrollpage: 0,
      responsiveNav: false,
      active: [],
      responsiveOthePageslist: false,
      responsiveBlogList: false,
      display: false
    };
  },
  methods: {
    handleScroll: function () {
      this.scrollpage = window.scrollY;
      if (this.scrollpage < 740) {
        this.active = [];
        this.active["home"] = true;
      } else if (this.scrollpage > 740 && this.scrollpage < 1530) {
        this.active = [];
        this.active["about"] = true;
      } else if (this.scrollpage > 1530 && this.scrollpage < 2222) {
        this.active = [];
        this.active["feature"] = true;
      } else if (this.scrollpage > 2222 && this.scrollpage < 2750) {
        this.active = [];
        this.active["work"] = true; 
      } else if (this.scrollpage > 2750 && this.scrollpage < 3650) {
        this.active = [];
        this.active["screenshot"] = true;
      } else if (this.scrollpage > 3650 && this.scrollpage < 5980) {
        this.active = [];
        this.active["team"] = true;
      } else if (this.scrollpage > 5980 && this.scrollpage < 6678) {
        this.active = [];
        this.active["blog"] = true;
      } else if (this.scrollpage > 6678) {
        this.active = [];
        this.active["contactUs"] = true;
      }
    },
    goto(refName) {
      let toPosition = this.windowPositions[refName];
      
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
    menuhandleScroll() {
          if (window.scrollY > 100) {
            this.display = true;
          } else {
            this.display = false;
          }
        },
  },
  created: function () {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener('scroll', this.menuhandleScroll);
  },
};
</script>
